var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLibraryIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66675 4H29.3334M2.66675 12H14.6667M2.66675 20H10.6667M2.66675 28H8.00008",
    stroke: "#C2C2C2",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7865 29.3334C16.5574 29.3334 17.2968 29.0271 17.8419 28.482C18.387 27.9369 18.6932 27.1976 18.6932 26.4267C18.6932 25.6558 18.387 24.9165 17.8419 24.3714C17.2968 23.8263 16.5574 23.52 15.7865 23.52C15.0157 23.52 14.2763 23.8263 13.7312 24.3714C13.1861 24.9165 12.8799 25.6558 12.8799 26.4267C12.8799 27.1976 13.1861 27.9369 13.7312 28.482C14.2763 29.0271 15.0157 29.3334 15.7865 29.3334Z",
    stroke: "#C2C2C2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3334 24.4933V13.1467C29.3334 10.7333 27.8134 10.4 26.28 10.8133L20.48 12.4C19.4267 12.6933 18.6934 13.52 18.6934 14.7333V26.4267",
    stroke: "#C2C2C2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6934 18.1334L29.3334 15.2267M26.4267 27.4C27.1976 27.4 27.9369 27.0938 28.482 26.5487C29.0271 26.0036 29.3334 25.2642 29.3334 24.4934C29.3334 23.7225 29.0271 22.9831 28.482 22.438C27.9369 21.8929 27.1976 21.5867 26.4267 21.5867C25.6558 21.5867 24.9165 21.8929 24.3714 22.438C23.8263 22.9831 23.52 23.7225 23.52 24.4934C23.52 25.2642 23.8263 26.0036 24.3714 26.5487C24.9165 27.0938 25.6558 27.4 26.4267 27.4Z",
    stroke: "#C2C2C2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibraryIcon);
export default __webpack_public_path__ + "static/media/library_icon.d18b85c200fc28437b062d9be8784ba6.svg";
export { ForwardRef as ReactComponent };